import { http } from 'helpers/http';

const URL = process.env.REACT_APP_API ?? '';
const registerCompanyMember = 'company/register-member';
const login = 'authentication/login';
const cdn = 'cdn/upload';
const forgotPass = 'authentication/forgot-password';
const registerCompany = 'company/registration';

export interface LoginPayload {
  readonly email: string;
  readonly password: string;
  readonly user_level: string;
}

export interface CompanyPayload {
  readonly company_id: string;
  readonly name: string;
  readonly logo: string;
}

export interface LoginData {
  readonly token: string;
  readonly company: CompanyPayload;
  readonly user_id: string;
  readonly user_level: string;
  readonly name: string;
  readonly profile: string;
}

export interface ApiResponse<TData> {
  readonly data: TData;
  readonly message: string;
}

export interface RegisterCompanyMemberPayload {
  readonly name: string;
  readonly email: string;
  readonly password: string;
  readonly registration_code: string;
}

export interface ForgotPasswordPayload {
  readonly email: string;
}

export const apiRegisterCompanyMember = async (
  val: RegisterCompanyMemberPayload,
): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + registerCompanyMember}`, val);
  return datas.data;
};

export const apiLogin = async (val: LoginPayload): Promise<ApiResponse<LoginData>> => {
  const datas = await http.post(`${URL + login}`, val);
  return datas.data;
};

export const apiCdn = async (val: FormData): Promise<unknown> => {
  const datas = await http.post(`${URL + cdn}`, val);
  return datas.data.data;
};

export const apiForgotPass = async (
  val: ForgotPasswordPayload,
): Promise<ApiResponse<unknown>> => {
  const datas = await http.post(`${URL + forgotPass}`, val);
  return datas.data;
};

export const apiRegisterCompany = async (val: unknown): Promise<unknown> => {
  const datas = await http.post(`${URL + registerCompany}`, val);
  return datas.data.data;
};
